var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-input-group",
        [
          _c(
            "b-dropdown",
            {
              staticClass: "flex-grow-1",
              attrs: {
                disabled: _vm.isDisabled,
                variant: "outline-secondary",
                size: "sm",
                "no-caret": "",
                "toggle-class":
                  "d-flex justify-content-between align-items-center bg-white text-dark border shadow-none",
                "menu-class": "z-index-dropdown"
              },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function() {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "text-truncate mr-2",
                          class:
                            _vm.selectedIds.length === 0
                              ? "text-muted"
                              : "text-dark"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.displayText) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "text-muted",
                        attrs: { icon: "chevron-down", size: "xs" }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "b-dropdown-form",
                {
                  staticClass: "p-1",
                  attrs: { boundary: "viewport" },
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "mb-2",
                    attrs: {
                      size: "sm",
                      placeholder: "Поиск...",
                      autocomplete: "off"
                    },
                    model: {
                      value: _vm.query,
                      callback: function($$v) {
                        _vm.query = $$v
                      },
                      expression: "query"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "options-container" },
                    [
                      _c(
                        "b-form-checkbox-group",
                        {
                          staticClass: "text-small",
                          attrs: { stacked: "" },
                          on: { change: _vm.onSelectionChange },
                          model: {
                            value: _vm.selectedIds,
                            callback: function($$v) {
                              _vm.selectedIds = $$v
                            },
                            expression: "selectedIds"
                          }
                        },
                        _vm._l(_vm.filteredItems, function(option) {
                          return _c(
                            "b-form-checkbox",
                            {
                              key: option.id,
                              staticClass: "mb-1",
                              attrs: { value: option.id }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(option.name) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.filteredItems.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-muted text-small p-2" },
                            [
                              _vm._v(
                                "\n            Ничего не найдено\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.selectedIds.length === 0 || _vm.isDisabled
                  },
                  on: { click: _vm.onClear }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              ),
              _vm._v(" "),
              _vm.canCreateCatalog()
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isDisabled
                      },
                      on: { click: _vm.showModalCatalog }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalVisible
        ? _c("driver-license-category", {
            attrs: { "exact-id": 0 },
            on: {
              "modal-closed": function($event) {
                _vm.isModalVisible = false
              },
              refresh: _vm.onDriverLicenseCategoryCreated
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7171bf2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7171bf2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/DriverLicenseCategories/DriverLicenseCategoriesMultiSelect.vue
// module id = null
// module chunks = 